<template>
  <div class="navbar-header">
<!--    <a id="mobile_btn" href="javascript:void(0);">-->
<!--        <span class="bar-icon">-->
<!--            <span></span>-->
<!--            <span></span>-->
<!--            <span></span>-->
<!--        </span>-->
<!--    </a>-->
    <div class="navbar-brand logo">
      <div class="img-fluid bg-logo" style="width: 182px; height: 46px; "/>
    </div>

    <mainnav></mainnav>

  </div>
</template>
<script>
import Helper from "../../src/helpers/helper.service";

export default {
  name: "Navbar",
  computed: {
    getTheme() {
      return Helper.getTheme()
    }
  },
}
</script>
